import {observer} from "mobx-react";
import React from "react";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ContentButtonTable} from "@dropDesk/presentation/pages/panel_adm/ui/painel_adm/payments_history/table/styled";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";


const RefundPay = observer(
    ({
         payment,
         onClickRefundPay,
     }: {
        payment: PaymentEntity,
        onClickRefundPay: (payment: PaymentEntity) => void
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const getContent = (payment: PaymentEntity): React.ReactNode => {
            if (payment.isPaid) {
                return (
                    <ContentButtonTable
                        onClick={() => onClickRefundPay(payment)}
                        size={15}
                        color={SharedColors.white}
                        background={colors.textError}
                        accent={colors.accent}
                        style={{border: 'none'}}
                    >
                        Estornar
                    </ContentButtonTable>
                )
            } else {
                return null;
            }
        }

        return (
            <>
                {getContent(payment)}
            </>
        )
    })
export default RefundPay;
